import { FormattedMessage } from 'react-intl';

import { supplierGridProperties } from '../../data/suppliers-properties';
import { messages } from '../messages';

type SupplierData = {
  countryCode: string;
};

const name = <FormattedMessage {...messages.supplierCountryColumnHeader} />;

/**
 * Country column configuration
 * Displays country for suppliers
 */
export const supplierCountry = {
  name,
  render: (data: SupplierData) => data.countryCode,
  id: supplierGridProperties.supplierCountry,
};
